import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaVirus, FaClock, FaHandSparkles, FaArrowRight, FaCheckCircle, FaCommentAlt, FaInfoCircle, FaCouch, FaBed, FaChair } from 'react-icons/fa';
import './NettoyageMobiliersPage.css';
import sofabg from '../assets/interieur-luxe/interieur-luxe1.jpg'; // Reusing some assets for consistency

// Images placeholders (using Unsplash for premium feel)
const SOFA_IMG = "https://images.unsplash.com/photo-1550254478-ead40cc54513?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80";
const MATTRESS_IMG = "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80";
const CHAIR_IMG = "https://images.unsplash.com/photo-1519947486511-46149fa0a254?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80";
const RUG_IMG = "https://images.unsplash.com/photo-1534882197683-10e8d356c9a3?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80";

const CATEGORIES = [
    { id: 'canapes', name: 'Canapés', icon: <FaCouch />, label: 'Toutes tailles' },
    { id: 'matelas', name: 'Matelas', icon: <FaBed />, label: 'Sain & Propre' },
    { id: 'autres', name: 'Autres', icon: <FaChair />, label: 'Tapis & Chaises' }
];

const FORMULAS = {
    canapes: [
        { name: "CANAPÉ 2 PLACES", price: 80, subtitle: "Idéal pour petits espaces", features: ["Aspiration profondeur", "Extraction injections", "Détachage ciblé", "Traitement odeurs", "Désinfection vapeur"], img: SOFA_IMG },
        { name: "CANAPÉ 3 PLACES", price: 90, subtitle: "Standard familial", featured: true, features: ["Pack Standard inclus", "Nettoyage accoudoirs", "Arrière des dossiers", "Désinfection textile", "Séchage accéléré"], img: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" },
        { name: "CANAPÉ D'ANGLE", price: 120, subtitle: "Entretien XL", features: ["Pack Premium inclus", "Nettoyage méridienne", "Traitement des recoins", "Shampouinage intégral", "Parfum textile luxe"], img: "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" }
    ],
    matelas: [
        { name: "1 PLACE (90cm)", price: 40, subtitle: "Hygiène parfaite", features: ["Injection-Extraction", "Anti-acariens radical", "Élimination auréoles", "Désinfection vapeur", "Séchage naturel"], img: MATTRESS_IMG },
        { name: "2 PLACES (140/160cm)", price: 60, subtitle: "Sommeil réparateur", featured: true, features: ["Nettoyage intégral", "Traitement bactérien", "Vapeur haute pression", "Extraction poussière", "Fraîcheur durable"], img: "https://images.unsplash.com/photo-1505693419163-5f5b40288cd7?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" },
        { name: "KING SIZE (180+)", price: 80, subtitle: "L'excellence santé", features: ["Soin exhaustif", "Traitement en profondeur", "Extraction maximale", "Stérilisation vapeur", "Protection textile"], img: "https://images.unsplash.com/photo-1540518614846-7eded433c457?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" }
    ],
    autres: [
        { name: "CHAISES / FAUTEUILS", price: 10, subtitle: "Dès 10€ par assises", features: ["Nettoyage dossier & siège", "Détachage textile", "Désinfection vapeur", "Shampouinage rapide", "Résultat visible"], img: CHAIR_IMG },
        { name: "TAPIS / MOQUETTES", price: "Devis", subtitle: "Sur mesure", featured: true, features: ["Analyse du textile", "Méthode adaptée", "Nettoyage fibre à fibre", "Ravive les couleurs", "Protection longue durée"], img: RUG_IMG },
        { name: "INTERVENTIONS PRO", price: "Devis", subtitle: "Bureaux & Commerces", features: ["Audit sur place", "Tarifs dégressifs", "Horaires flexibles", "Continuité d'activité", "Contrat d'entretien"], img: "https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" }
    ]
};

const NettoyageMobiliersPage = () => {
    const [selectedCat, setSelectedCat] = useState('canapes');

    return (
        <div className="mobiliers-page-wrapper">
            {/* Smart Selector Section (Start directly without banner) */}
            <section className="selection-trigger-section">
                <div className="container">
                    <motion.div className="selector-header center">
                        <span className="premium-label">EXPERTISE TEXTILE & CUIR</span>
                        <h2 className="section-title">Quel <span className="text-gradient-blue">mobilier</span> nettoyer ?</h2>
                    </motion.div>

                    <div className="type-selector-grid">
                        {CATEGORIES.map((cat) => (
                            <button
                                key={cat.id}
                                className={`type-card ${selectedCat === cat.id ? 'active' : ''}`}
                                onClick={() => setSelectedCat(cat.id)}
                            >
                                <div className="type-icon">{cat.icon}</div>
                                <div className="type-info">
                                    <span className="type-name">{cat.name}</span>
                                    <span className="type-label">{cat.label}</span>
                                </div>
                                {selectedCat === cat.id && <motion.div layoutId="active-bg-mob" className="active-glow" />}
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            {/* Pricing Matrix Section */}
            <section className="pricing-matrix-section">
                <div className="container">
                    <div className="pricing-grid-premium">
                        <AnimatePresence mode="wait">
                            {FORMULAS[selectedCat].map((formula, idx) => (
                                <motion.div
                                    key={`${selectedCat}-${formula.name}`}
                                    className={`pricing-card-premium ${formula.featured ? 'featured' : ''}`}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    transition={{ duration: 0.4, delay: idx * 0.1 }}
                                >
                                    <div className="pricing-card-img-wrapper">
                                        <img src={formula.img} alt={formula.name} />
                                        <div className="card-badge">{formula.name}</div>
                                        <div className="card-overlay"></div>
                                    </div>
                                    <div className="pricing-card-content">
                                        <div className="category-tag">{formula.subtitle}</div>
                                        <ul className="formula-features">
                                            {formula.features.map((feat, i) => (
                                                <li key={i}><FaCheckCircle className="check-icon" /> {feat}</li>
                                            ))}
                                        </ul>
                                        <div className="pricing-footer">
                                            <div className="price-info">
                                                <span className="price-from">dès</span>
                                                <span className="price-value">{typeof formula.price === 'number' ? `${formula.price}€` : formula.price}</span>
                                            </div>
                                            <Link 
                                                to="/reservation" 
                                                state={{ 
                                                    category: 'mobilier', 
                                                    mobilierCat: selectedCat, 
                                                    prestation: formula.name 
                                                }}
                                                className="btn-premium-small"
                                            >
                                                RÉSERVER <FaArrowRight />
                                            </Link>
                                        </div>
                                    </div>
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="mob-intro-section-premium">
                <div className="container">
                    <motion.div className="section-header-premium center">
                        <span className="premium-label">HYGIÈNE & SANTÉ</span>
                        <h2 className="section-title">Pourquoi nettoyer <span className="text-gradient-blue">vos tissus ?</span></h2>
                    </motion.div>

                    <div className="benefits-grid-premium">
                        <div className="benefit-card-premium">
                            <div className="benefit-icon-premium blue"><FaHandSparkles /></div>
                            <h3>Éclat Initial</h3>
                            <p>Éliminez tâches et ternissement pour redonner à votre mobilier son aspect neuf.</p>
                        </div>
                        <div className="benefit-card-premium">
                            <div className="benefit-icon-premium green"><FaVirus /></div>
                            <h3>Maison Saine</h3>
                            <p>Éliminez 99.9% des acariens et allergènes piégés dans les fibres textiles.</p>
                        </div>
                        <div className="benefit-card-premium">
                            <div className="benefit-icon-premium orange"><FaClock /></div>
                            <h3>Durabilité</h3>
                            <p>Un entretien régulier protège les fibres et prolonge la vie de votre canapé.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact CTA */}
            <section className="voiture-footer-cta-premium">
                <div className="container">
                    <div className="cta-card-premium has-accent">
                        <div className="cta-glow-effect"></div>
                        <div className="cta-content-wrapper">
                            <div className="cta-left">
                                <div className="cta-icon-box-premium"><FaCommentAlt /></div>
                                <div className="cta-text-content-premium">
                                    <h3>Un projet mobilier ?</h3>
                                    <p>Demandez votre devis personnalisé gratuitement pour vos matelas ou tapis.</p>
                                </div>
                            </div>
                            <div className="cta-right">
                                <Link to="/contact" className="btn-cta-premium">ME CONTACTER <FaArrowRight /></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer Notes */}
            <section className="station-footer-notes-premium">
                <div className="container">
                    <motion.div className="notes-container-premium">
                        <div className="notes-header-premium">
                            <FaInfoCircle className="info-icon-premium" />
                            <span>Informations Pratiques</span>
                        </div>
                        <div className="notes-body-premium">
                            <p>Toutes nos prestations incluent la désinfection vapeur et le traitement anti-acariens haute performance.</p>
                            <div className="premium-alert-box">
                                <strong>* Note :</strong> Les tarifs varient selon l'état d'encrassement et la nature des taches rencontrées.
                            </div>
                        </div>
                    </motion.div>
                </div>
            </section>
        </div>
    );
};

export default NettoyageMobiliersPage;
